//Core
import React, { useReducer } from "react"

//Action
import formActions from "../actions/formActions"

//Itils
import axios from "axios"

//Helpers
import {
  validateName,
  validatePhoneNumber,
  transformPhoneAfterMask,
  validateInn,
} from "../helpers/validation"

const {
  START_FETCH,
  FINISH_FETCH,
  FETCH_SUCCESS,
  FETCH_FAIL,
  CHANGE_PHONE,
  VALID_PHONE,
  CHECKED_PHONE,
  CHANGE_INN,
  CHECKED_INN,
  VALID_INN,
  FETCH_ERROR,
  SENDED_ORDER,
  SET_USER,
} = formActions

const initialState = {
  fetch: false,
  success: false,
  fail: false,
  error: false,
  user: {},
  sendOrderSuccess: false,
  phone: { valid: false, value: "", checked: false },
  inn: { valid: false, value: "", checked: false },
}

const reducer = (state, action) => {
  switch (action.type) {
    case START_FETCH:
      return { ...state, fetch: true }
    case FINISH_FETCH:
      return { ...initialState, user: state.user }
    case FETCH_SUCCESS:
      return { ...state, fetch: false, success: true }
    case FETCH_FAIL:
      return { ...state, fetch: false, fail: true }
    case FETCH_ERROR:
      return { ...state, fetch: false, error: true }
    case SENDED_ORDER:
      return { ...state, sendOrderSuccess: true }
    case SET_USER:
      return { ...state, user: action.payload }

    case CHANGE_INN:
      return { ...state, inn: { ...state.inn, value: action.payload } }
    case VALID_INN:
      return {
        ...state,
        inn: { ...state.inn, valid: action.payload },
      }

    case CHECKED_PHONE:
      return { ...state, phone: { ...state.phone, checked: true } }
    case CHECKED_INN:
      return { ...state, inn: { ...state.inn, checked: true } }

    case CHANGE_PHONE:
      return { ...state, phone: { ...state.phone, value: action.payload } }
    case VALID_PHONE:
      return {
        ...state,
        phone: { ...state.phone, valid: action.payload },
      }

    default:
      return state
  }
}

const useForm = link => {
  const [state, dispatch] = useReducer(reducer, initialState)

  //UI
  const startFetch = () => dispatch({ type: START_FETCH })
  const finishFetch = () => dispatch({ type: FINISH_FETCH })
  const fetchSuccess = () => dispatch({ type: FETCH_SUCCESS })
  const fetchFail = () => dispatch({ type: FETCH_FAIL })
  const fetchError = () => dispatch({ type: FETCH_ERROR })

  //BL
  const setUser = user => dispatch({ type: SET_USER, payload: user })
  const sendOrder = () => dispatch({ type: SENDED_ORDER })

  //Phone
  const checkedPhone = () => dispatch({ type: CHECKED_PHONE })
  const validPhone = isValidPhone =>
    dispatch({ type: VALID_PHONE, payload: isValidPhone })
  const changePhone = phone => {
    dispatch({ type: CHANGE_PHONE, payload: phone })
    const normalPhone = transformPhoneAfterMask(phone)

    const isValidPhone = validatePhoneNumber(normalPhone)
    validPhone(isValidPhone)
  }

  //Inn
  const checkedInn = () => dispatch({ type: CHECKED_INN })
  const validInn = isValidInn =>
    dispatch({ type: VALID_INN, payload: isValidInn })
  const changeInn = inn => {
    dispatch({ type: CHANGE_INN, payload: inn })
    const isValidInn = validateInn(inn)

    validInn(isValidInn)
  }

  const sendUserOrder = async () => {
    try {
      const res = await axios.post(
        `https://refinance.tascombank.ua/api/holiday/order`,
        state.user
      )
      res.status === 201 || res.status == 200 ? sendOrder() : fetchFail()
    } catch (error) {
      fetchFail()
    } finally {
      finishFetch()
    }
  }

  const onClick = async () => {
    try {
      console.log("CLICK!!!!")
      const { phone, inn } = state
      console.log("phone", phone)
      console.log("inn", inn)

      ///Transform form after mask
      const normalPhone = transformPhoneAfterMask(phone.value)

      //Validate fileds
      const isValidPhone = validatePhoneNumber(normalPhone)
      const isValidInn = validateInn(inn.value)

      console.log("inn", inn)
      console.log("isValidInn", isValidInn)
      console.log("state", state)

      checkedPhone()
      checkedInn()

      //Set fields
      validPhone(isValidPhone)
      validInn(isValidInn)

      if (isValidPhone && isValidInn) {
        startFetch()
        try {
          console.table({
            phone: normalPhone,
            inn: inn.value,
          })

          const res = await axios.post(link, {
            phone: normalPhone,
            inn: inn.value,
          })
          setUser({ phone: normalPhone, inn: inn.value })

          console.log(res)
          res.status === 201 || res.status == 200 ? fetchSuccess() : fetchFail()
        } catch (error) {
          console.dir(error)

          if (error.response.data.statusCode == 404) {
            fetchError()
          } else {
            fetchFail()
          }
        } finally {
          finishFetch()
        }
      }
    } catch (error) {
      console.log("eeee")
      console.log("err", error)
    }
  }

  return {
    state,

    checkedInn,
    changeInn,

    sendUserOrder,

    checkedPhone,
    changePhone,

    onClick,
  }
}

export default useForm
